import { smb_fetch, getAgsApiUrl } from '@/api/operator/fetch';

// 保存LG呼叫标签
export const callIdTagSave = (data: any = {}) => {
  const url = getAgsApiUrl('v2', 'call-center/dial-in/call-tag-save');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  return smb_fetch(url, params, true, false);
};
